import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ── Inject admin-managed scripts into the page ────────────────────
const injectScripts = async () => {
  const API = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
  const locations = ['head', 'body_start', 'body_end'];
  for (const location of locations) {
    try {
      const res = await fetch(`${API}/scripts/inject?location=${location}`, { signal: AbortSignal.timeout(3000) });
      if (!res.ok) continue; // silently skip on any error
      const code = await res.text();
      if (!code.trim()) continue;
      const el = document.createElement('div');
      el.innerHTML = code;
      const nodes = Array.from(el.childNodes).map(n => n.cloneNode(true));
      if (location === 'head') {
        nodes.forEach(n => document.head.appendChild(n));
      } else if (location === 'body_start') {
        const root = document.getElementById('root');
        nodes.forEach(n => root?.parentNode?.insertBefore(n, root));
      } else {
        nodes.forEach(n => document.body.appendChild(n));
      }
    } catch {
      // Always silent — never break the app or show errors
    }
  }
};

injectScripts();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
